// src/hooks/useResumenCargosAutomaticos.js
import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, limit, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';

export const useResumenCargosAutomaticos = () => {
    const { userData } = useAuth();
    const [resumenNoVisto, setResumenNoVisto] = useState(null);
    const [loading, setLoading] = useState(true);

    const fraccionamientoId = userData?.fraccionamientoId || userData?.fraccionamientoTd;

    useEffect(() => {
        let isMounted = true;
        if (!fraccionamientoId) {
            setLoading(false);
            return () => { isMounted = false; };
        }

        // Verificar si el usuario es administrador
        const userRole = (userData?.rol || '').toLowerCase();
        const isAdmin = ['admin', 'admin_fracc', 'administrador', 'manager', 'platformadmin', 'superadmin'].includes(userRole);

        if (!isAdmin) {
            setLoading(false);
            return () => { isMounted = false; };
        }

        // Buscar el resumen más reciente que no haya sido visto
        // SE ELIMINA ORDER BY para evitar requerir índice compuesto que causa error en la app
        const resumenesRef = collection(db, 'fraccionamientos', fraccionamientoId, 'resumenesCargosAutomaticos');
        const q = query(
            resumenesRef,
            where('visto', '==', false),
            limit(1)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            if (!isMounted) return;

            if (!snapshot.empty) {
                const resumenDoc = snapshot.docs[0];
                setResumenNoVisto({
                    id: resumenDoc.id,
                    ...resumenDoc.data()
                });
            } else {
                setResumenNoVisto(null);
            }
            setLoading(false);
        }, (error) => {
            if (isMounted) {
                console.error('Error cargando resumen de cargos automáticos:', error);
                setLoading(false);
            }
        });

        return () => {
            isMounted = false;
            unsubscribe();
        };
    }, [fraccionamientoId, userData?.rol]);

    const marcarComoVisto = async (resumenId) => {
        if (!fraccionamientoId || !resumenId) return;

        try {
            const resumenRef = doc(db, 'fraccionamientos', fraccionamientoId, 'resumenesCargosAutomaticos', resumenId);
            await updateDoc(resumenRef, {
                visto: true,
                vistoEn: new Date()
            });
            setResumenNoVisto(null);
        } catch (error) {
            console.error('Error marcando resumen como visto:', error);
        }
    };

    return {
        resumenNoVisto,
        loading,
        marcarComoVisto
    };
};

